






































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as data from "../../_store/data.module";
import * as user from "../../_store/user.module";

@Component
export default class CandidatureProposteLavoroDialog extends Vue {
  @Prop() params!: any;
  @Prop() idProposta!: number;
  @Prop() infoProposta!: any;
  private dialog: boolean;
  private search: string;
  private candidature: any;
  private loadingData: boolean;

  constructor() {
    super();
    this.dialog = false;
    this.search = "";
    this.candidature = this.params.records;
    this.loadingData = true;
  }

  @Watch('dialog')
  onchangeDialog(){
    if(this.dialog === true) {
      this.loadCandidature()
    }
  }

  close() {
    this.dialog = false;
    bus.$emit("destroyCandidatureDialog");
  }

  loadCandidature() {
    var payload = {
      idProposta: this.idProposta
    };
    data
      .dispatchCandidaturePropostaLavoro(this["$store"], payload)
      .then(result => {
        this.candidature = result;
        this.loadingData = false;
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  changeStatus(idCandidatura: number, colloquioAvvenuto: boolean) {
    if (colloquioAvvenuto === false) {
      colloquioAvvenuto = true;
    } else {
      colloquioAvvenuto = false;
    }
    var payload = {
      idCandidatura: idCandidatura,
      colloquioAvvenuto: colloquioAvvenuto
    };
    user
      .dispatchChangeStatusCandidatura(this["$store"], payload)
      .then(() => {
        this.loadCandidature();
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  downloadPdf(url: string, nomeAllievo: string, cognomeAllievo: string) {
    const linkSource = `data:application/pdf;base64,${url}`;
    const downloadLink = document.createElement("a");
    // const fileName = "cv.pdf"
    const fileName = "CV_" + cognomeAllievo + "_" + nomeAllievo + ".pdf";
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  // created() {
  //   this.loadCandidature();
  // }
}
